import Vue from 'vue';
import Errors from '../classes/Errors';

Vue.component('settings-component', {
    props: {
        options: {
          type: Array,
          required: true,
        },
        default: {
          type: String,
          required: false,
          default: null,
        },
        tabindex: {
          type: Number,
          required: false,
          default: 0,
        },
        currentSettingsTab: {
          type: String,
          required: false,
          default: null,
        },
        selectedSlug: {
          type: String,
          required: false,
          default: null,
        }
      },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            dropdownOpen: false,
            selected: this.default
            ? this.default
            : this.options.length > 0
            ? this.options[0]
            : null,
            open: false,
            currentTab: null,
            newImageUploaded: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() { 
        Vue.nextTick(() => {
            this.selected = this.options.find(obj => {
                return obj.slug === this.selectedSlug;
            })
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        readURL(e) { 
            const [file] = e.currentTarget.files;
            if (file) {
                document.querySelector('#user-photo').src = URL.createObjectURL(file);
                this.newImageUploaded = true;
            }
        }
    }
});
